import { useState } from 'react';
import { PageHeader } from '../components/common';
import { CertificateIcon, SettingsIcon } from '../components/icons';
import { CertificateTemplateEditor } from '../components/settings';
import { Box, Tab, Tabs } from '../components/ui';

type SettingsTab = 'certificate-template';

export default function SettingsPage() {
  const [selectedTab, setSelectedTab] = useState<SettingsTab>('certificate-template');

  return (
    <Box sx={{ p: 4 }}>
      <PageHeader
        icon={<SettingsIcon />}
        title="Settings"
        subtitle="Manage your account configuration"
      />

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={selectedTab} onChange={(_e, value) => setSelectedTab(value)} aria-label="settings tabs">
          <Tab label="Certificate Template" value="certificate-template" icon={<CertificateIcon />} iconPosition="start" />
        </Tabs>
      </Box>

      {selectedTab === 'certificate-template' && <CertificateTemplateEditor />}
    </Box>
  );
}
